import EmailStage from './components/EmailStage'
import StripeStage from './components/StripeStage'
import Navigation from 'features/common/components/Navigation'
import Header from 'features/common/components/Header'

import useOnboardingPage from '../common/hooks/useEmailCode/useOnboardingPage/useOnboardingPage'
import {useNavigate} from 'react-router-dom'
import {useUser} from 'features/authorized/context/user'
import {useEffect} from 'react'
import {
    PageContainer,
    PageSidebar,
    PageContentContainer,
    PageContentHeader,
    PageContent,
} from 'features/common/components/Page'

const OnboardingPage = () => {
    const {stage, onClickBack} = useOnboardingPage()
    const navigate = useNavigate()

    const {user} = useUser()

    useEffect(() => {
        if (!user) {
            navigate('/auth')
            return
        }
        if (user.onboarding.completed) {
            navigate('/')
            return
        }
    }, [user, navigate])

    return (
        <PageContainer>
            <PageSidebar>
                <Navigation />
            </PageSidebar>

            <PageContentContainer>
                <PageContentHeader>
                    <Header onClickBack={onClickBack} />
                </PageContentHeader>
                <PageContent>
                    <div className="flex h-full w-full flex-1 overflow-x-hidden">
                        {stage === 'email' ? <EmailStage /> : null}
                        {stage === 'stripe' ? <StripeStage /> : null}
                    </div>
                </PageContent>
            </PageContentContainer>
        </PageContainer>
    )
}

export default OnboardingPage
